<div class="bg_calculator">
  <div class="header__cupra">
    <nav class="navbar navbar-expand-lg px-0 py-2 py-md-3">
      <div class="container">
        <a class="navbar-brand" href="https://www.cupraofficial.es/">
          <img class="logo-cupra" src="../../../../assets/images/cupra-logo.svg" width="126px" alt="CUPRA">
        </a>
        <ul class="navbar-nav mt-1">
          <li class="nav-item"><a class="nav-link" href="https://www.cupraofficial.es/">Sitio web CUPRA</a></li>
          <li class="nav-item"><a class="nav-link" href="/">Volver</a></li>
        </ul>
      </div>
    </nav>
  </div>
  <div class="header__calculator">
    <div class="container">
      <div class="header__img">
        <img src="../../../../assets/images/header-cookies.jpg" class="w-100" alt="Matenimiento oficial Cupra">
      </div>
    </div>

    <div class="container">
      <div class="header__title">
        <h1>Política de Cookies</h1>
        <a class="btn btn-secondary" href="/">Volver</a>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="row">
      <div class="col">
        <p><b>1. ¿Qué son las cookies?</b><br>
          <br>
          Las cookies son ficheros que almacenan y recuperan información sobre los hábitos de navegación del usuario. La información que se obtiene está relacionada, por ejemplo, con&nbsp; el número de nuevos usuarios, la frecuencia y reincidencia de las visitas, el tiempo que dura la misma, el navegador o el equipo desde el que se realiza la visita o se ejecuta la aplicación.
        </p>
        <p><b>2. ¿Qué tipos de cookies utiliza www.cupraofficial.es?</b><br>
          <br>
          Las cookies que utiliza este sitio web son las siguientes:
        </p>

        <div>
          <h3>Lista de cookies</h3>
          <div>Una cookie es un fragmento pequeño de datos (archivos de texto) que un sitio web, cuando es visitado por un usuario, le pregunta a su navegador para almacenarse en su dispositivo y así recordar información acerca de usted, como por ejemplo la preferencia de idioma o su información para iniciar sesión. Estas cookies son establecidas por nosotros, y se llaman cookies de primeras partes. También usamos cookies de terceras partes (que son cookies de un dominio diferente al dominio del sitio web que está visitando) para nuestros estudios de anuncios y marketing. Específicamente, usamos las cookies y otras tecnologías de seguimiento para los siguientes propósitos:</div>
          <section class="mt-3">
            <h4>Cookies de rendimiento</h4>
            <p>Estas cookies nos permiten contar las visitas y fuentes de circulación para poder medir y mejorar el desempeño de nuestro sitio web. Nos ayudan a saber qué páginas son las más o menos populares, y ver cuántas personas visitan el sitio. Toda la información que recogen estas cookies es agregada y, por lo tanto, anónima. Si el usuario no permite estas cookies no sabremos cuándo visitó nuestro sitio web.
            </p>
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>Cookie</th>
                  <th>Duración</th>
                  <th>Descripción</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>_ga_TLPDK1KZWD</td>
                  <td>2 años</td>
                  <td>
                    <p>Esta cookie es instalada por Google Analytics, calcula los datos de visitantes, sesiones y campañas y también realiza un seguimiento del uso del sitio para el informe analítico del sitio. La cookie almacena información de forma anónima y asigna un número generado aleatoriamente para reconocer a visitantes únicos.le Analytics.</p>
                  </td>
                </tr>
                <tr>
                  <td>_ga</td>
                  <td>2 años</td>
                  <td>
                    <p>La cookie _ga, instalada por Google Analytics, calcula los datos de visitantes, sesiones y campañas y también realiza un seguimiento del uso del sitio para el informe analítico del sitio. La cookie almacena información de forma anónima y asigna un número generado aleatoriamente para reconocer a visitantes únicos.</p>
                  </td>
                </tr>
              </tbody>
            </table>

          </section>
          <section>
            <h4>Cookies estrictamente necesarias</h4>
            <p>Estas cookies son necesarias para que el sitio web funcione y no se pueden desactivar en nuestros sistemas. Usualmente están configuradas para responder a acciones hechas por el usuario para recibir servicios, tales como ajustar sus preferencias de privacidad, iniciar sesión en el sitio, o llenar formularios. El usuario puede configurar su navegador para bloquear o alertar la presencia de estas cookies, pero algunas partes del sitio web no funcionarán.
            </p>
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>Cookie</th>
                  <th>Duración</th>
                  <th>Descripción</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>cc_cookie</td>
                  <td>1 año</td>
                  <td>
                    <p>Esta cookie se establece para recordar las preferencias de consentimiento de los usuarios para que se respeten sus preferencias en sus visitas posteriores a este sitio. No recopila ni almacena ninguna información personal de los visitantes del sitio.</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </section>
        </div>


        <div>
          <p><b>3. ¿Cómo administrar las cookies?</b><br>
          </p>
        </div>


      </div>
      <div>
        <div>
          <div><button class="btn btn-dark" data-cc="show-preferencesModal">Configurar o rechazar opcionales</button></div>
        </div>
      </div>
      <div>

        <div>
          <p><br>
            Además, el usuario tiene la opción de permitir, bloquear o eliminar las cookies instaladas en su equipo mediante la configuración de las opciones del navegador instalado en su terminal.</p>
          <p>No obstante, la inhabilitación de las cookies podría modificar el funcionamiento del sitio web.&nbsp;Por favor, consulte las instrucciones y manuales de su navegador para ampliar esta información.</p>
          <p>Tenga en cuenta que, si acepta las cookies de terceros, deberá eliminarlas desde las opciones del navegador o desde el sistema ofrecido por el propio tercero.</p>
          <p><b>4.&nbsp;¿A qué países se transferirán mis datos?</b><br>
            <br>
            Sus datos no serán transferidos a países que se encuentren fuera del Espacio Económico Europeo (EEE). No obstante, si hubiese una transferencia de sus datos a terceros países, la transferencia será llevada a cabo en base a una decisión de adecuación o cualquier otra medida que ofrezca las garantías adecuadas.
          </p>
          <p>Puedes informarte sobre las transferencias a terceros países que, en su caso, realizan los terceros identificados en esta Política de Cookies en sus correspondientes políticas.</p>
          <p><b></b>Para el resto de información del artículo 13 del Reglamento General de Protección de Datos (RGPD), incluyendo los derechos de los interesados, consulta nuestra <a href="https://www.cupraofficial.es/politica-privacidad.html" target="_blank">Política de Privacidad</a>.</p>

        </div>


      </div>

    </div>

    <div class="row py-5">
      <div class="col"><a class="btn btn-secondary float-end" href="/">Volver</a></div>
    </div>
  </div>
</div>